import styled from '@emotion/styled';
import { css_gap, css_if, css_medium_down } from '~/emotion/theme';

const Padding = styled.div<{ $vertical?: boolean }>`
	display: flex;
	flex-direction: column;
	padding-left: ${(props) => props.theme.margin.left};
	padding-right: ${(props) => props.theme.margin.right};
	padding-top: ${css_if('$vertical', css_gap('section'), 0)};
	padding-bottom: ${css_if('$vertical', css_gap('section'), 0)};

	.fill:has(&) + .fill:has(&) & {
		padding-top: 0;
	}

	@media (${css_medium_down}) {
		.row:not(.fill):has(&) + .row:not(.fill):has(&) & {
			padding-top: 0;
		}
	}
`;

export default function MicrositePadding({ id, children, vertical }: { children: React.ReactNode; id?: string; vertical?: boolean }) {
	return (
		<Padding id={id} $vertical={vertical}>
			{children}
		</Padding>
	);
}
